import { render } from "./FixSameBusinessID.vue?vue&type=template&id=38bf48fc"
import script from "./FixSameBusinessID.vue?vue&type=script&lang=js"
export * from "./FixSameBusinessID.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__